import getCompositeItemPosition from '../../../common/helpers/get-composite-item-position';
import toPositionPercents from './to-position-percents';

const STEP = 2.5;
const MAX_POSITION = 100;

function calculateDuplicatedItemPosition(item, breakpoint = null) {
  const { x, y } = getCompositeItemPosition({ element: item, breakpoint });
  const position = [x, y].map((value) => Math.min(MAX_POSITION, value + STEP));

  return toPositionPercents(position);
}

export default calculateDuplicatedItemPosition;
